<template>
<h1>登录成功，正在跳转.....</h1>
</template>

<script>
export default {
  name: "SociableSuccess",
  created() {
    let geturl = window.location.href
    let getqyinfo = geturl.split('?')[1]
    let getqys = new URLSearchParams('?'+getqyinfo)
    let id = getqys.get('id')
    let token = getqys.get('token')

    localStorage.setItem('id',id)
    localStorage.setItem('token',token)
    this.$router.replace('/index/buy')
  }
}
</script>

<style scoped>

</style>